module.exports = __webpack_public_path__ + "media/images/front/clinicwiki/arrow_small-1005c0276f84898f4b4301b74a278e88.png";